import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  standalone: false,
  selector: "app-profile-primary-capability-badge",
  templateUrl: "./profile-primary-capability-badge.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./profile-primary-capability-badge.component.css"],
})
export class ProfilePrimaryCapabilityBadgeComponent {
  @Input() capabilityName!: string;
}
